var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "container-fluid",
    staticStyle: {
      "overflow-y": "scroll",
      "height": "520px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "text-left"
  }, [_vm._v(_vm._s(_vm.datiGeneraliLbl))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "border-top": "1px solid lightgray",
      "content": "''",
      "top": "20px",
      "right": "10em",
      "vertical-align": "top",
      "bottom": "0",
      "width": "100%"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('span', {
    staticClass: "align-middle label-cust"
  }, [_vm._v(_vm._s(_vm.riferimentoLbl))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.riferimentoValue),
      expression: "riferimentoValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "readonly": "",
      "type": "text",
      "id": "riferimentoId"
    },
    domProps: {
      "value": (_vm.riferimentoValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.riferimentoValue = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('cfg', {
    attrs: {
      "cid": "shopCart.vsRif",
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('span', {
    staticClass: "align-middle label-cust"
  }, [_vm._v(_vm._s(_vm.vostroRiferimentoLbl))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vostroRiferimentoValue),
      expression: "vostroRiferimentoValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "readonly": "",
      "type": "text",
      "id": "vostroRiferimentoId"
    },
    domProps: {
      "value": (_vm.vostroRiferimentoValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.vostroRiferimentoValue = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('cfg', {
    attrs: {
      "cid": "shopCart.tipoOrdine",
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('span', {
    staticClass: "align-middle label-cust"
  }, [_vm._v(_vm._s(_vm.tipoOrdineLbl))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tipoOrdineValue.type),
      expression: "tipoOrdineValue.type"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "readonly": "",
      "type": "text",
      "id": "tipoOrdineId"
    },
    domProps: {
      "value": (_vm.tipoOrdineValue.type)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tipoOrdineValue.type = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('cfg', {
    attrs: {
      "cid": "shopCart.scontoBase",
      "tag": "div"
    }
  }, [(!_vm.$root.token.hidePrices && _vm.showScontoBase) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('span', {
    staticClass: "align-middle label-cust"
  }, [_vm._v(_vm._s(_vm.scontoBaseLbl))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scontoBaseValue),
      expression: "scontoBaseValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "readonly": "",
      "type": "text",
      "id": "scontoBaseId"
    },
    domProps: {
      "value": (_vm.scontoBaseValue)
    },
    on: {
      "change": _vm.scontoBaseChangeEvent,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.scontoBaseValue = $event.target.value
      }
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('cfg', {
    attrs: {
      "cid": "shopCart.note",
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-2"
  }, [_c('span', {}, [_vm._v(_vm._s(_vm.noteLbl))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.noteValue),
      expression: "noteValue"
    }],
    staticClass: "form-control",
    staticStyle: {
      "max-width": "100%",
      "max-height": "138px"
    },
    attrs: {
      "readonly": "",
      "id": "noteId",
      "rows": "2",
      "data-role": "textarea"
    },
    domProps: {
      "value": (_vm.noteValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.noteValue = $event.target.value
      }
    }
  })])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    staticClass: "text-left"
  }, [_vm._v(_vm._s(_vm.datiConsegnaLbl))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "border-top": "1px solid lightgray",
      "content": "''",
      "top": "20px",
      "right": "10em",
      "vertical-align": "top",
      "bottom": "0",
      "width": "100%"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nominativoConsegna),
      expression: "nominativoConsegna"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "readonly": "",
      "type": "text",
      "id": "nominativoConsegnaId"
    },
    domProps: {
      "value": (_vm.nominativoConsegna)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nominativoConsegna = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.indirizzoConsegna),
      expression: "indirizzoConsegna"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "readonly": "",
      "type": "text",
      "id": "indirizzoConsegnaId"
    },
    domProps: {
      "value": (_vm.indirizzoConsegna)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.indirizzoConsegna = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.locCapConsegna),
      expression: "locCapConsegna"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "readonly": "",
      "type": "text",
      "id": "locCapConsegnaId"
    },
    domProps: {
      "value": (_vm.locCapConsegna)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.locCapConsegna = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nazioneConsegna),
      expression: "nazioneConsegna"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "readonly": "",
      "type": "text",
      "id": "nazioneConsegnaId"
    },
    domProps: {
      "value": (_vm.nazioneConsegna)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nazioneConsegna = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('cfg', {
    attrs: {
      "cid": "shopCart3.shippingType",
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('span', {
    staticClass: "align-middle label-cust"
  }, [_vm._v(_vm._s(_vm.tipoSpedLbl))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tipoSped),
      expression: "tipoSped"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "readonly": "",
      "type": "text",
      "id": "spedizione"
    },
    domProps: {
      "value": (_vm.tipoSped)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tipoSped = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('cfg', {
    attrs: {
      "cid": "shopCart3.portType",
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('span', {
    staticClass: "align-middle label-cust"
  }, [_vm._v(_vm._s(_vm.tipoPortLbl))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tipoPort),
      expression: "tipoPort"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "readonly": "",
      "type": "text",
      "id": "porto"
    },
    domProps: {
      "value": (_vm.tipoPort)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tipoPort = $event.target.value
      }
    }
  })])])]), _vm._v(" "), (_vm.showReqDeliveryDate) ? _c('cfg', {
    attrs: {
      "cid": "shopCart3.deliveryDate",
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('span', {
    staticClass: "align-middle label-cust"
  }, [_vm._v(_vm._s(_vm.dataConsegnaLbl))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataConsegna),
      expression: "dataConsegna"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "readonly": "",
      "type": "text",
      "id": "data"
    },
    domProps: {
      "value": (_vm.dataConsegna)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dataConsegna = $event.target.value
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.showUnifyDelivery) ? _c('cfg', {
    attrs: {
      "cid": "shopCart3.unifyDelivery",
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('span', {
    staticClass: "align-middle label-cust"
  }, [_vm._v(_vm._s(_vm.accorpaSpedLbl))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accorpaSped),
      expression: "accorpaSped"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "readonly": "",
      "type": "text",
      "id": "accorpa"
    },
    domProps: {
      "value": (_vm.accorpaSped)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.accorpaSped = $event.target.value
      }
    }
  })])])]) : _vm._e()], 1), _vm._v(" "), _c('cfg', {
    attrs: {
      "cid": "shopCart.importo",
      "tag": "div"
    }
  }, [(!_vm.$root.token.hidePrices) ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', {
    staticClass: "text-left"
  }, [_vm._v(_vm._s(_vm.importoLbl))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "border-top": "1px solid lightgray",
      "content": "''",
      "top": "20px",
      "right": "10em",
      "vertical-align": "top",
      "bottom": "0",
      "width": "100%"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.importoValue),
      expression: "importoValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "readonly": "",
      "type": "text",
      "id": "importoValueId"
    },
    domProps: {
      "value": (_vm.importoValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.importoValue = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('span', {
    staticClass: "align-middle"
  }, [_vm._v(" ")])])]) : _vm._e()]), _vm._v(" "), (_vm.isAlternate) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "text-left"
  }, [_vm._v(_vm._s(_vm.richiedenteLbl))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "border-top": "1px solid lightgray",
      "content": "''",
      "top": "20px",
      "right": "10em",
      "vertical-align": "top",
      "bottom": "0",
      "width": "100%"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nomeRicValue),
      expression: "nomeRicValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "readonly": "",
      "type": "text",
      "id": "nomeRicValueId"
    },
    domProps: {
      "value": (_vm.nomeRicValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nomeRicValue = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mailRicValue),
      expression: "mailRicValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "readonly": "",
      "type": "text",
      "id": "indirizzoConsegnaId"
    },
    domProps: {
      "value": (_vm.mailRicValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mailRicValue = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.faxRicValue),
      expression: "faxRicValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "readonly": "",
      "type": "text",
      "id": "locCapConsegnaId"
    },
    domProps: {
      "value": (_vm.faxRicValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.faxRicValue = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telRicValue),
      expression: "telRicValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "readonly": "",
      "type": "text",
      "id": "nazioneConsegnaId"
    },
    domProps: {
      "value": (_vm.telRicValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.telRicValue = $event.target.value
      }
    }
  })])])])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('grid', {
    attrs: {
      "columns": _vm.gridProdAttributesCfg.columns,
      "source": _vm.arrayToTable,
      "options": _vm.options,
      "others": _vm.others,
      "lang": _vm.$root.token.idLingua,
      "name": _vm.gridProdAttributesCfg.title
    },
    on: {
      "update:source": function($event) {
        _vm.arrayToTable = $event
      }
    }
  })], 1)])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('button', {
    staticClass: "btn btn-primary-default",
    staticStyle: {
      "width": "100%"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.previousClick($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.indietroBtnLbl))])]), _vm._v(" "), _c('cfg', {
    staticClass: "col-sm-3",
    attrs: {
      "cid": "shopCart.nuovoOrdineBtn",
      "tag": "div"
    }
  }, [_c('button', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "width": "100%"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.cleanShopCartClick($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate('new order')))])]), _vm._v(" "), _c('cfg', {
    staticClass: "col-sm-4",
    attrs: {
      "cid": "shopCart.printPreviewBtn",
      "tag": "div"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary-default",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": !_vm.orderSynced
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$root.printOrder(_vm.riferimentoValue)
      }
    }
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate('print preview')))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn btn-warning",
    staticStyle: {
      "width": "100%"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.saveDraft($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.salvaBozzaBtnLbl))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": !_vm.orderSynced
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.sendOrder($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.inviaBtnLbl))])])]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sendingCart),
      expression: "sendingCart"
    }],
    staticStyle: {
      "opacity": "1",
      "background": "rgba(255, 255, 255, 0.65)",
      "z-index": "9999",
      "position": "fixed",
      "top": "0",
      "left": "0",
      "width": "100vw",
      "height": "100vh",
      "transition": "opacity 0.3s",
      "transform": "translate3D(0, 0, 0)"
    },
    attrs: {
      "id": "sendingCart"
    }
  }, [_vm._m(2)])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md"
  }, [_vm._v(" ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md"
  }, [_vm._v(" ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sk-cube-grid",
    staticStyle: {
      "margin-top": "20%"
    }
  }, [_c('div', {
    staticClass: "sk-cube sk-cube1 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube2 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube3 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube4 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube5 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube6 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube7 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube8 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube9 loading-nav-waiter"
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-039dc918","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/shopcart/ShopCart3.vue
// module id = 1682
// module chunks = 1